<div
  class="popup"
  [class.is-open]="open()"
  role="dialog"
  aria-modal="true"
  [attr.aria-labelledby]="coupon() ? 'enquiry-thanks' : 'enquiry-headline'"
  [attr.aria-hidden]="!open()"
>
  <div class="popup__backdrop" (click)="popups.close()"></div>

  <div class="popup__dialog enquiry" [class.is-success]="coupon()">
    <button type="button" class="popup__close" aria-label="Close enquiry form" (click)="popups.close()">&times;</button>

    @if (coupon(); as code) {
      <div class="enquiry__main">
        <div class="thanks" aria-live="polite">
          <div class="thanks__tick" aria-hidden="true">&#10003;</div>
          <h3 id="enquiry-thanks">Thank you! Your ₹500 coupon is ready</h3>
          <p>Our comfort team will be in touch shortly. Use this code at checkout on littlenap.in.</p>
          <div class="code">
            <code>{{ code }}</code>
            <button type="button" class="code__copy" [class.is-copied]="copied()" (click)="copy(code)" data-popup-focus>
              {{ copied() ? 'Copied' : 'Copy' }}
            </button>
          </div>
          <ul class="terms">
            <li>
              ₹500 off, valid on littlenap.in only — not valid in showrooms or on Amazon, Flipkart, Pepperfry or Urban
              Ladder.
            </li>
            <li>One coupon per customer. Cannot be clubbed with other running offers.</li>
            <li>Minimum order value and expiry apply as per current offer terms.</li>
          </ul>
          <a class="thanks__shop" [href]="shopHref" target="_blank" rel="noopener">Start Shopping</a>
        </div>
      </div>
    } @else {
      <aside class="enquiry__aside">
        <span class="badge">
          <span class="badge__amount">₹500</span>
          <span class="badge__label">Off your first online order</span>
        </span>
        <h2 class="enquiry__headline" id="enquiry-headline">Your Perfect Recliner Starts Here</h2>
        <p class="enquiry__sub">
          Tell us about your space and our comfort experts will help you choose — and we’ll hand you a ₹500 coupon the
          moment you submit.
        </p>
        <ul class="points">
          <li>Made to order, built around your room</li>
          <li>Pan-India sales and service</li>
          <li>A decade of recliner craftsmanship</li>
        </ul>
      </aside>

      <div class="enquiry__main">
        <h3 class="enquiry__title">Claim your ₹500 coupon</h3>
        <p class="enquiry__note">Fields marked <span class="req">*</span> are required.</p>

        <form class="form" (submit)="submit($event)" novalidate>
          <div class="field">
            <input
              class="input"
              [class.has-error]="errors().uname"
              type="text"
              name="uname"
              placeholder="Full Name *"
              aria-label="Full name"
              autocomplete="name"
              required
              data-popup-focus
            />
            @if (errors().uname) {
              <span class="error">This field is required!</span>
            }
          </div>
          <div class="field">
            <input
              class="input"
              [class.has-error]="errors().umobile"
              type="text"
              name="umobile"
              placeholder="Phone Number"
              aria-label="Phone number"
              autocomplete="tel-national"
              inputmode="numeric"
              maxlength="10"
            />
            @if (errors().umobile) {
              <span class="error">Enter a valid 10-digit mobile number.</span>
            }
          </div>
          <div class="field">
            <input
              class="input"
              [class.has-error]="errors().uemail"
              type="email"
              name="uemail"
              placeholder="Email Address"
              aria-label="Email address"
              autocomplete="email"
            />
            @if (errors().uemail) {
              <span class="error">Invalid email format!</span>
            }
          </div>
          <div class="field">
            <input
              class="input"
              type="text"
              name="location"
              placeholder="Location"
              aria-label="Location"
              autocomplete="address-level2"
            />
          </div>
          <div class="field field--wide">
            <textarea #message class="input" rows="3" name="umessage" placeholder="Message" aria-label="Message"></textarea>
          </div>
          <div class="field field--wide">
            <label class="captcha__label" for="enquiry-captcha">
              What is {{ sum()?.[0] }} + {{ sum()?.[1] }}? <span class="req">*</span> (Security question)
            </label>
            <input
              class="input input--captcha"
              type="text"
              id="enquiry-captcha"
              name="captcha"
              inputmode="numeric"
              autocomplete="off"
              required
            />
            @if (errors().captcha) {
              <span class="error">Please answer the security question.</span>
            }
          </div>
          <p class="form__problem" role="alert">{{ problem() }}</p>
          <button type="submit" class="form__submit">Submit</button>
          <p class="form__privacy">
            By submitting you agree to be contacted about your enquiry. Coupon valid on littlenap.in only, one per
            customer.
          </p>
        </form>
      </div>
    }
  </div>
</div>
